module.exports = __webpack_public_path__ + "static/media/icon-questions-green.807c7f00.svg";